// Soccer Mode — scripts propios (prefijo mt-). Vanilla JS, sin librerias externas.
(function () {
  'use strict';

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
    // Red de seguridad: si por lo que sea el observador no dispara (pestaña en
    // segundo plano, navegador raro, etc.), aseguramos que el contenido se
    // muestre igual pasado un momento en vez de quedar invisible para siempre.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
    }, 1800);
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-figura-principal]');
      var minis = galeria.querySelectorAll('[data-mt-miniatura]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          if (!src) return;
          principal.removeAttribute('srcset');
          principal.removeAttribute('sizes');
          principal.src = src;
          principal.alt = alt;
          minis.forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
        });
      });
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-mt-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[data-mt-tab-btn]');
      var panels = wrap.querySelectorAll('[data-mt-tab-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-mt-tab-btn');
          btns.forEach(function (b) { b.classList.remove('is-activo'); });
          panels.forEach(function (p) { p.classList.remove('is-activo'); });
          btn.classList.add('is-activo');
          var panel = wrap.querySelector('[data-mt-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('is-activo');
        });
      });
    });
  }

  function formatoDinero(centavos) {
    var soles = (centavos / 100).toFixed(2);
    return 'S/ ' + soles;
  }

  function initSelectorProducto() {
    document.querySelectorAll('[data-mt-producto-form]').forEach(function (root) {
      var dataEl = root.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var opciones = root.querySelectorAll('[data-mt-opcion]');
      var idInput = root.querySelector('[data-mt-variant-id]');
      var precioEl = root.querySelector('[data-mt-precio]');
      var precioAntesEl = root.querySelector('[data-mt-precio-antes]');
      var precioBadgeEl = root.querySelector('[data-mt-precio-badge]');
      var botonComprar = root.querySelector('[data-mt-boton-comprar]');
      var estadoTexto = root.querySelector('[data-mt-estado-stock]');

      function seleccionActual() {
        var sel = {};
        opciones.forEach(function (grupo) {
          var nombre = grupo.getAttribute('data-mt-opcion');
          var activo = grupo.querySelector('.is-activo');
          if (activo) sel[nombre] = activo.getAttribute('data-valor');
        });
        return sel;
      }

      function encontrarVariante(sel) {
        return variantes.find(function (v) {
          return Object.keys(sel).every(function (k) { return v.opciones[k] === sel[k]; });
        });
      }

      function actualizarDisponibilidad() {
        var sel = seleccionActual();
        opciones.forEach(function (grupo) {
          var nombre = grupo.getAttribute('data-mt-opcion');
          grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
            var prueba = Object.assign({}, sel);
            prueba[nombre] = btn.getAttribute('data-valor');
            var v = encontrarVariante(prueba);
            btn.disabled = !v || !v.disponible;
          });
        });
      }

      function actualizar() {
        var sel = seleccionActual();
        var v = encontrarVariante(sel);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (precioEl) precioEl.textContent = formatoDinero(v.precio);
        if (precioAntesEl) {
          if (v.precioAntes && v.precioAntes > v.precio) {
            precioAntesEl.textContent = formatoDinero(v.precioAntes);
            precioAntesEl.style.display = '';
            if (precioBadgeEl) {
              var pct = Math.round((1 - v.precio / v.precioAntes) * 100);
              precioBadgeEl.textContent = pct + '% OFF';
              precioBadgeEl.style.display = '';
            }
          } else {
            precioAntesEl.style.display = 'none';
            if (precioBadgeEl) precioBadgeEl.style.display = 'none';
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !v.disponible;
          botonComprar.textContent = v.disponible
            ? botonComprar.getAttribute('data-texto-disponible')
            : botonComprar.getAttribute('data-texto-agotado');
        }
        if (estadoTexto) {
          estadoTexto.textContent = v.disponible ? '' : (estadoTexto.getAttribute('data-texto-agotado') || '');
        }
        actualizarDisponibilidad();
      }

      opciones.forEach(function (grupo) {
        grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            var hermanos = grupo.querySelectorAll('[data-valor]');
            hermanos.forEach(function (h) { h.classList.remove('is-activo'); });
            btn.classList.add('is-activo');
            var etiqueta = grupo.querySelector('[data-mt-valor-activo]');
            if (etiqueta) etiqueta.textContent = btn.getAttribute('data-valor');
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  var ZONA_PERU = 'America/Lima';

  function ahoraEnPeru() {
    var partes = new Intl.DateTimeFormat('en-US', {
      timeZone: ZONA_PERU, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date());
    var obj = {};
    partes.forEach(function (p) { obj[p.type] = p.value; });
    var hora = obj.hour === '24' ? 0 : parseInt(obj.hour, 10);
    return {
      fecha: new Date(Date.UTC(parseInt(obj.year, 10), parseInt(obj.month, 10) - 1, parseInt(obj.day, 10))),
      hora: hora,
      minuto: parseInt(obj.minute, 10)
    };
  }

  function formatoFechaCorta(fechaUtcMedianoche) {
    return new Intl.DateTimeFormat('es-PE', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(fechaUtcMedianoche);
  }

  function sumarDias(fechaUtcMedianoche, dias) {
    var copia = new Date(fechaUtcMedianoche.getTime());
    copia.setUTCDate(copia.getUTCDate() + dias);
    return copia;
  }

  function initEnvioTimeline() {
    document.querySelectorAll('[data-mt-envio-timeline]').forEach(function (root) {
      var corte = parseInt(root.getAttribute('data-corte'), 10);
      var procMin = parseInt(root.getAttribute('data-proc-min'), 10);
      var procMax = parseInt(root.getAttribute('data-proc-max'), 10);
      var transMin = parseInt(root.getAttribute('data-transito-min'), 10);
      var transMax = parseInt(root.getAttribute('data-transito-max'), 10);

      var cuentaEl = root.querySelector('[data-mt-envio-cuenta]');
      var hoyEl = root.querySelector('[data-mt-envio-hoy]');
      var enviadoEl = root.querySelector('[data-mt-envio-enviado]');
      var entregadoEl = root.querySelector('[data-mt-envio-entregado]');

      function render() {
        var ahora = ahoraEnPeru();
        var antesDeCorte = ahora.hora < corte;
        var baseFecha = antesDeCorte ? ahora.fecha : sumarDias(ahora.fecha, 1);

        if (hoyEl) hoyEl.textContent = antesDeCorte ? 'Hoy' : 'Mañana';

        if (enviadoEl) {
          var envMin = sumarDias(baseFecha, procMin);
          var envMax = sumarDias(baseFecha, procMax);
          enviadoEl.textContent = formatoFechaCorta(envMin) + ' – ' + formatoFechaCorta(envMax);
        }
        if (entregadoEl) {
          var entMin = sumarDias(baseFecha, procMin + transMin);
          var entMax = sumarDias(baseFecha, procMax + transMax);
          entregadoEl.textContent = formatoFechaCorta(entMin) + ' – ' + formatoFechaCorta(entMax);
        }
        if (cuentaEl) {
          if (antesDeCorte) {
            var minRestantes = (corte - ahora.hora) * 60 - ahora.minuto;
            var h = Math.floor(minRestantes / 60);
            var m = minRestantes % 60;
            cuentaEl.innerHTML = 'Si pides en las próximas <strong>' + h + ' h ' + m + ' min</strong>, tu pedido sale hoy';
          } else {
            cuentaEl.innerHTML = 'Los pedidos de hoy salen <strong>mañana</strong>';
          }
        }
      }

      render();
      setInterval(render, 60000);
    });
  }

  function initBundles() {
    document.querySelectorAll('[data-mt-bundles]').forEach(function (wrap) {
      var items = wrap.querySelectorAll('[data-mt-bundle]');
      var formRoot = wrap.closest('[data-mt-producto-form-el]') || document;
      var cantidadInput = formRoot.querySelector('[data-mt-bundle-cantidad]');
      items.forEach(function (item) {
        item.addEventListener('click', function () {
          items.forEach(function (i) { i.classList.remove('is-activo'); });
          item.classList.add('is-activo');
          if (cantidadInput) cantidadInput.value = item.getAttribute('data-cantidad') || '1';
        });
      });
    });
  }

  function initAcordeon() {
    document.querySelectorAll('[data-mt-acordeon-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-acordeon__item');
        var abierto = item.classList.toggle('is-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initMenuMovil() {
    // Reservado: Dawn ya gestiona su propio menu movil nativo.
  }

  function initLazyVideos() {
    var videos = document.querySelectorAll('[data-mt-lazy-video]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        var source = video.querySelector('source[data-src]');
        if (source) { source.src = source.getAttribute('data-src'); video.load(); }
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var video = entry.target;
          var source = video.querySelector('source[data-src]');
          if (source && !source.getAttribute('src')) {
            source.src = source.getAttribute('data-src');
            video.load();
            video.play().catch(function () {});
          }
          obs.unobserve(video);
        });
      },
      { rootMargin: '250px' }
    );
    videos.forEach(function (video) { obs.observe(video); });
  }

  function initAll() {
    initReveals();
    initGaleriaProducto();
    initTabs();
    initSelectorProducto();
    initEnvioTimeline();
    initBundles();
    initAcordeon();
    initLazyVideos();
    initMenuMovil();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
